// import { CommonArray, CommonQueryType, ProductType, SimilarProductType } from '@/utils/types';
import { cleanObject } from "@/utils/helpers";
import baseApi from ".";
import { UserRoleType } from "@/utils/types";
import queryTagTypes from "./queryTagTypes";

const commonApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoleList: builder.query<
      any,
      {
        isSuperAdmin?: boolean;
        search?: string;
        type?: string;
        page?: number;
        pageSize?: number;
        sortBy?: string;
        sortOrder?: string;
        status?: string | number;
      }
    >({
      query: (params) => ({
        url: "/roles",
        method: "GET",
        params: cleanObject(params),
      }),
      providesTags: [],
      transformResponse: (response: { data: any }) => response.data,
    }),
    getRoleDetail: builder.query<
      UserRoleType,
      number | string
    >({
      query: (id) => ({
        url: `/roles/${id}`,
        method: "GET",
      }),
      providesTags: [queryTagTypes.ROLE_QUERY_TAG],
    }),
    updateRole: builder.mutation<
    any, 
    { id: string | number; body: any }
    >({
      query: ({ id, body }) => ({
        url: `/roles/${id}`,
        method: "PUT",
        body: {
          ...body
        },
      }),
      invalidatesTags: (_, error) =>
        error ? [] : [],
    }),
    getCallingCodeList: builder.query<any, any>({
      query: (params) => ({
        url: "/users/calling-code",
        method: "GET",
        params: cleanObject(params),
      }),
      providesTags: [],
      transformResponse: (response: { data: any }) => response.data,
    }),
  }),
});

export default commonApi;
export const { useGetRoleListQuery, useGetRoleDetailQuery, useUpdateRoleMutation, useGetCallingCodeListQuery } = commonApi;
